export default __webpack_public_path__ + "static/media/AWS_logo_RGB_WHT.6a960fd0.svg";